import {
  IMohAgreementHolder,
  IPractice,
  isStaffer,
  IStaffer,
  MohAgreementHolderSource,
} from '@principle-theorem/principle-core/interfaces';
import { IReffable, isSameRef, WithRef } from '@principle-theorem/shared';

export class MohAgreementHolder {
  static resolveSource(
    practice: Pick<IPractice, 'mohSettings'>
  ): MohAgreementHolderSource {
    return (
      practice.mohSettings?.agreementHolderSource ??
      MohAgreementHolderSource.Practitioner
    );
  }

  static claimsUnderPractice(
    practice: Pick<IPractice, 'mohSettings'>
  ): boolean {
    return (
      MohAgreementHolder.resolveSource(practice) ===
      MohAgreementHolderSource.Practice
    );
  }

  static fromProvider(
    provider: WithRef<IStaffer> | WithRef<IPractice>,
    practice: IReffable<IPractice>
  ): IMohAgreementHolder {
    return isStaffer(provider)
      ? MohAgreementHolder.fromPractitioner(provider, practice)
      : MohAgreementHolder.fromPractice(provider);
  }

  static fromPractice(practice: IPractice): IMohAgreementHolder {
    return {
      source: MohAgreementHolderSource.Practice,
      payeeNumber: practice.mohSettings?.payeeNumber ?? '',
      agreementNumber: practice.mohSettings?.agreementNumber ?? '',
      agreementHolderName:
        practice.mohSettings?.agreementHolderName || practice.name,
    };
  }

  static fromPractitioner(
    practitioner: IStaffer,
    practice: IReffable<IPractice>
  ): IMohAgreementHolder {
    const details = practitioner.metadata?.nz?.practiceProviderDetails?.find(
      (detail) => isSameRef(detail.practiceRef, practice.ref)
    );
    return {
      source: MohAgreementHolderSource.Practitioner,
      payeeNumber: details?.payeeNumber ?? '',
      agreementNumber: details?.agreementNumber ?? '',
      agreementHolderName: practitioner.user.name,
    };
  }
}
